import { Reducer } from "redux";

import { SaveDisciplineLevelNote } from "../models/Api/Notes";
import { SaveDisciplineLevelNotesDispatchTypes } from "../models/DispatchTypes/Notes";
import { SaveDisciplineLevelNotesActionDispatchTypes } from "../constants/Notes";

export const initialState: SaveDisciplineLevelNote = {
  loading: false,
  response: {
    disciplineNoteId: -1,
    serviceRequestDisciplineId: -1,
    noteEntryId: -1,
    dateCreated: "",
    dateUpdated: "",
    userCreated: "",
    fullNameCreated: "",
    noteTemplateId: -1,
    templateName: "",
    noteEntryJson: "",
    comment: "",
    highestCred: null,
  },
};

const SaveDisciplineLevelNotesReducer: Reducer<
  SaveDisciplineLevelNote,
  SaveDisciplineLevelNotesDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case SaveDisciplineLevelNotesActionDispatchTypes.SAVE_DISCIPLINE_NOTES_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case SaveDisciplineLevelNotesActionDispatchTypes.SAVE_DISCIPLINE_NOTES_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case SaveDisciplineLevelNotesActionDispatchTypes.SAVE_DISCIPLINE_NOTES_RESET: {
      return initialState;
    }
  }
  return state;
};

export default SaveDisciplineLevelNotesReducer;
